import { useState } from 'react';

/**
 * Swiper needs its navigation buttons as elements, not refs, and only picks them up once they
 * exist. Holding them in state re-renders the slider when they mount.
 */
export const useSwiperNavigation = () => {
    const [prevEl, setPrevEl] = useState<HTMLButtonElement | null>(null);
    const [nextEl, setNextEl] = useState<HTMLButtonElement | null>(null);

    return { navigation: { prevEl, nextEl }, prevRef: setPrevEl, nextRef: setNextEl };
};
